// eslint-disable-next-line require-jsdoc
export default function tuple(...args) {
  return args;
}